import * as TYPES from '../types';

export const getAllTeamAction = (payload) => {
    return {
        type: TYPES.GET_ALL_TEAM_MEMBERS,
        payload: payload
    };
};

export const getAllTeamSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_TEAM_MEMBERS_SUCCESS,
        payload: payload
    };
};